var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 24,
    viewBox: "0 0 396 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 21H353",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 3.00001L396 3",
    stroke: "#3ED4DC",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundTop);
export default __webpack_public_path__ + "static/media/background-top.954067d05583fb9f9f05a004d5871526.svg";
export { ForwardRef as ReactComponent };